export const ModalActions = {
  labelDeliveryDate: 'Entrega prevista a:',
  labelConfirmDate: 'Confirmar Recolha a:',
  labelDeliveryReasson: 'Motivo:',
  labelPeriod: 'Período do Dia',
  labelDeliveryDisableDate: 'Data de Entrega',
  labelEditRegistration: 'Matricula a Alterar',
  labelHour: 'Seleccione uma Hora:',
  datePlaceholder: 'Seleccione uma Data',
  hourPlaceholder: 'Seleccione uma Hora',
  modalTitleReschedule: 'Re-Agendar Entrega',
  modalTitlePeriod: 'Alterar Período de Entrega',
  modalTitleDelivery: 'Pedidos Entregues',
  modalTitleRestore: 'Restaurar Pedidos Entregues',
  modalTitleCollected: 'Pedido(s) Recolhido(s)',
  modalTitleIncidence: 'Reportar Incidência',
  modalTitleEditRegistration: 'Editar Matricula',
  modalTitleRegistration: 'Associar Matricula',
  modalTitleAddDriver: 'Associar Motorista',
  modalTitleCollect: 'Confirmar Recolha',
  modalTitleUploadPod: 'Upload Ficheiro',
  orderByChoiseUser3: 'Escolher Periodo de Entrega',
  MORNING: 'Manhã',
  AFTERNOON: 'Tarde',
  incidenceChoise1: 'Momento',
  incidenceChoise2: 'Tipo',
  incidenceChoise3: 'Subtipo',
  incidenceChoise4: 'Motivo',
  rescheduleChoise1: 'Motivo do Reagendamento',
  rescheduleChoise2: 'Justificação do Reagendamento',
  rescheduleChoise3: 'Justificação do Tipo do Reagendamento',
  registrationChoise1: 'Matriculas',
  addDriverChoise1: 'Motoristas',
  restore: 'Pretende restaurar este(s) pedido(s)???',
  collected: 'Recolheu este(s) pedido(s)???',
  photo: 'Adicionar Fotografia',
  changedRegistration: 'A matricula {registration} foi atribuida ao motorista {driverName}',
  removeRegistration: ' sendo retirada ao motorista {lastDriver}',
  labelLoadPOD: 'Adicionar POD',
  labelPods: 'Já registados <b>{lenPods}</b> PODs.',
  labelFile: 'Ficheiro'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/ModalActions.js